import { ReactNode } from "react";
import { ResponsiveContainer } from "./ResponsiveContainer";

interface PageWrapperProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

export function PageWrapper({
  children,
  title,
  subtitle,
  actions,
  maxWidth = 'xl'
}: PageWrapperProps) {
  return (
    <ResponsiveContainer maxWidth={maxWidth}>
      <div className="space-y-4 sm:space-y-5 md:space-y-6">
        {(title || actions) && (
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
            <div>
              {title && (
                <h1 className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-foreground to-foreground/80 bg-clip-text text-transparent">
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-sm sm:text-base text-muted-foreground mt-1">
                  {subtitle}
                </p>
              )}
            </div>
            {actions && (
              <div className="flex gap-2 flex-wrap">
                {actions}
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </ResponsiveContainer>
  );
}
